import * as imagesLoaded from 'imagesloaded'
import SmoothScroll from './class/SmoothScroll'
import common from './common'
import index from './index'
import partials from './partials'

let smoother
document.addEventListener('DOMContentLoaded', function() {
  partials().then(() => {
    imagesLoaded(document.getElementById('app'), () => {
      common()
      index()
      initSmoothScroll()
    })
  })
})

function initSmoothScroll(){
  const wv = 1024 - 1
  const ss = new SmoothScroll({
    wrapper: document.getElementById('viewport'),
    content: document.getElementById('container'),
    smooth: 0.1,
    tweenEase: 'power2.out',
    tweenDuration: 0.7,
    hashBehavior: 'push',
    offset: -8   // 固定ヘッダ分があれば調整
  })

  if(window.innerWidth > wv){
    ss.init()
    window.addEventListener('load', () => ss.reset())
  }

  function isResize(){
    if(window.innerWidth > wv){
      ss.destroy()
      ss.init()
    }else{
      ss.destroy()
    }
  }
  window.addEventListener('resize', isResize)
}



